import React, { useRef, useContext, useCallback, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import FocusTrap from './components/FocusTrap/index.js';
import IconButton from './components/IconButton/index.js';
import OnlyUIRender from './components/OnlyUIRender/index.js';
import { createPortal } from 'react-dom';
import { c as classnames } from './index-2586sEvh.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import useAnimate from './hooks/useAnimate.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-tjIjLI8L.js';
import 'next/router';
import useGetPortalRoot from './hooks/useGetPortalRoot.js';
import 'notistack';
import useWindowSize from './hooks/useWindowSize.js';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import { g as gsapWithCSS } from './index-RkBJ48Nr.js';
import { UtilityIcons } from './types/index.js';
import './checkout-Ee1eEXQH.js';
import './menu-0TyOg98i.js';
import './modal-6vnX5SO3.js';

gsapWithCSS.config({ nullTargetWarn: false });
const DrawerContent = ({ children, open, name, position = 'right', onClose, }) => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const PORTAL_ID = `drawer-root_${name}`;
    const bodyRef = useRef(document.querySelector('body'));
    const [portalRoot, isVisible] = useGetPortalRoot(open, PORTAL_ID);
    const drawerRef = useRef(null);
    const backdropRef = useRef(null);
    const { data: { siteConfig: { header: { leftDrawerUtilities = false, mobileMenuIconOrder = [UtilityIcons.Currency, UtilityIcons.Language], } = {}, }, }, } = useContext(CoreContext);
    const { width } = useWindowSize();
    let drawerPosition = position;
    const parsedMobileMenuIconOrder = mobileMenuIconOrder === null || mobileMenuIconOrder === void 0 ? void 0 : mobileMenuIconOrder.map(item => item.toLowerCase());
    if (leftDrawerUtilities && (parsedMobileMenuIconOrder === null || parsedMobileMenuIconOrder === void 0 ? void 0 : parsedMobileMenuIconOrder.includes(name)) && width <= 660) {
        drawerPosition = 'left';
    }
    // Allow Escape key to dismiss the drawer
    // Using "useCallback" to avoid an issue with different function reference on component rerender
    // which can cause to incorrect removing of event listeners
    const onKeyUp = useCallback((e) => {
        if (e.key !== 'Escape')
            return;
        onClose();
    }, []);
    const animate = () => {
        const animData = (() => {
            switch (drawerPosition) {
                case 'left':
                    return { from: { x: '-100%' }, to: { x: '0%' } };
                case 'right':
                    return { from: { x: '100%' }, to: { x: '0%' } };
                case 'top':
                    return { from: { y: '-100%' }, to: { y: '0%' } };
                case 'bottom':
                    return { from: { y: '100%' }, to: { y: '0%' } };
                default:
                    return { from: { x: '100%' }, to: { x: '0%' } };
            }
        })();
        const drawerAnimation = gsapWithCSS
            .fromTo(drawerRef.current, { ...animData.from, ease: 'none' }, { ...animData.to, duration: 0.5, ease: 'power3.in' })
            .pause();
        const backdropAnimation = gsapWithCSS
            .fromTo(backdropRef.current, { opacity: 0 }, { opacity: 1, duration: 0.5 })
            .pause();
        if (open) {
            drawerAnimation.play();
            backdropAnimation.play();
        }
        else {
            drawerAnimation.reverse(0);
            backdropAnimation.reverse(0);
        }
    };
    const onOpenEvents = () => {
        bodyRef.current.style.overflow = 'hidden';
        window.addEventListener('keyup', onKeyUp);
    };
    const onCloseEvents = () => {
        bodyRef.current.style.overflow = '';
        window.removeEventListener('keyup', onKeyUp);
        animate();
    };
    useEffect(() => {
        if (open) {
            onOpenEvents();
        }
        else {
            onCloseEvents();
        }
    }, [open]);
    useEffect(() => () => {
        // Always remove event listeners on unMount
        onCloseEvents();
    }, []);
    useEffect(() => {
        if (drawerRef.current) {
            animate();
        }
    }, [drawerRef.current]);
    const animateRef = useRef(null);
    useAnimate(animateRef);
    if (!portalRoot)
        return null;
    return (React.createElement(React.Fragment, null, createPortal(React.createElement(React.Fragment, null,
        React.createElement("div", { "aria-hidden": open ? 'false' : 'true', ref: drawerRef, className: classnames('drawer', position, { in: isVisible }), role: "dialog", "aria-label": tLabel('sideMenu') },
            React.createElement("div", { ref: animateRef, className: "drawer-content" }, children)),
        React.createElement("div", { ref: backdropRef, className: "backdrop", role: "presentation", onClick: onClose })), portalRoot)));
};

const Drawer = (props) => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { children, onClose, position, isSmall = false } = props;
    let dataGsap = position === 'left' ? `fade-right` : 'fade-left';
    if (isSmall) {
        dataGsap = '';
    }
    return (
    // Using OnlyUIRender wrapper
    // To deny a render of the Modal component on SSR
    // because there is no access to a "document" and "window" objects
    React.createElement(OnlyUIRender, null,
        React.createElement(DrawerContent, { ...props },
            React.createElement(FocusTrap, null,
                React.createElement("div", { "data-gsap": dataGsap }, children),
                React.createElement(IconButton, { btnClassName: "btn-close", iconClassName: "icon-close", title: tLabel('closeModal'), onClick: onClose, "data-gsap": "spin", "data-gsap-delay": "0.2", "data-gsap-custom-value": position === 'left' ? '-360' : '' })))));
};

export { Drawer as D };
//# sourceMappingURL=Drawer-67hWckPj.js.map
